import { styled } from "@pigment-css/react";
import { pressInteraction } from "@acto/taskpane/field-sales-2/styles/pressInteraction";

/**
 * The full-width pill CTA shared across every recap-flow screen — "Weiter" / "Bestätigen" on the
 * compose/summary screens and "Speichern" on the two edit screens. Named for the ROLE (it is the
 * primary action of whichever screen hosts it), not for any single label.
 */
export const PrimaryActionButton = styled("button")<{ fullWidth?: boolean }>(({ theme }) => ({
  width: "100%",
  height: theme.fieldSalesTwo.spacing[50],
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  borderRadius: theme.fieldSalesTwo.radius.circular,
  background: theme.fieldSalesTwo.colors.charts.primary,
  color: "#fff",
  cursor: "pointer",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.subtle,
  transition: "filter 120ms ease, transform 120ms ease",
  ...pressInteraction(theme),
  "&:hover": { filter: "brightness(0.93)" },
  "&:disabled": { opacity: 0.5, pointerEvents: "none" },
  variants: [{ props: { fullWidth: false }, style: { width: "auto", flex: 1 } }],
}));
